import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { modal, container, loader } from './recipe-modal.module.scss';
import { getSingleRecipeAction } from '../../../redux/recipes/single/actions/get-single-recipe';

import CustomModal from '../../../templates/custom-modal';
import Loader from '../../atoms/loader';
import RecipeContent from '../recipe-content';

interface IRecipePreviewModal {
    modalId: number;
    recipeId: number;
}

const RecipePreviewModal = ({ modalId, recipeId }: IRecipePreviewModal) => {
    const dispatch = useDispatch();
    const recipe = useSelector((state: any) =>
        state.recipes.single.get.data?.id === recipeId ? state.recipes.single.get.data : null
    );

    useEffect(() => {
        dispatch(getSingleRecipeAction(recipeId));
    }, [dispatch, recipeId]);

    return (
        <CustomModal modalId={modalId} className={modal} imageOnTop={true}>
            {recipe ? (
                <div className={container}>
                    <RecipeContent
                        recipe={recipe}
                        portions={1}
                        simpleView={true}
                        onIngredientChange={() => {}}
                    />
                </div>
            ) : (
                <Loader className={loader} />
            )}
        </CustomModal>
    );
};

export default RecipePreviewModal;
